import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(2, 0),
  borderRadius: '12px',
  boxShadow: 'none',
  backgroundColor: 'rgba(249, 250, 251, 1)',
  border: '1px solid #e5e7eb',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: '#f3f4f6',
  color: '#374151',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  padding: theme.spacing(1, 2),
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#e5e7eb',
    borderColor: '#9ca3af',
  },
}));


const TraderQuestion = ({ 
  firstSection, 
  secondSection, 
  onAddTrader,
  onRemoveTrader,
  disabled = false,
  hasTrader = false
}) => {
  // Get trader operation state to disable buttons during API calls
  const traderOperationState = useSelector((state) => state.form?.traderOperation || {});
  const isProcessing = traderOperationState.isProcessing;

  const handleAddTrader = () => {
    if (onAddTrader && !isProcessing) {
      onAddTrader(firstSection, secondSection);
    }
  };

  const handleRemoveTrader = () => {
    if (onRemoveTrader && !isProcessing) {
      onRemoveTrader(firstSection, secondSection);
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <StyledPaper elevation={1}>
        <Typography
          variant="h6"
          sx={{
            color: '#374151',
            fontWeight: 600,
            fontSize: '16px',
            textAlign: 'center',
            marginBottom: 2,
          }}
        >
          Is there a trader between "{firstSection}" and "{secondSection}"?
        </Typography>
        
        {!hasTrader ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <StyledButton
              variant="outlined"
              onClick={handleAddTrader}
              disabled={disabled || isProcessing}
              sx={{
                minWidth: '200px',
              }}
            >
              {isProcessing ? 'Processing...' : 'Yes, and add a new trader section'}
            </StyledButton>
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="body2"
              sx={{
                color: '#10b981',
                fontWeight: 500,
                marginBottom: 2,
              }}
            >
              Responded "Yes", and New Trader Section Added below
            </Typography>
            <StyledButton
              variant="outlined"
              onClick={handleRemoveTrader}
              disabled={disabled || isProcessing}
              sx={{
                minWidth: '300px',
              }}
            >
              {isProcessing ? 'Processing...' : 'Click to change Response to "No", and remove the trader section'}
            </StyledButton>
          </Box>
        )}
      </StyledPaper>
    </Box>
  );
};

export default TraderQuestion;
